import { Control, FieldErrors, FieldPath } from 'react-hook-form';
import { ReactElement } from 'react';
import CountryAndStateField from 'components/forms/CountryAndStateDropdownField';
import FormInput from 'components/forms/FormInput';

export interface AddressFormInputProps<TFieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
}

export default function AddressFormInput<TFieldValues>(
  props: AddressFormInputProps<TFieldValues>,
): ReactElement {
  const { control, errors } = props;

  return (
    <div>
      <FormInput
        fieldName={'address1' as FieldPath<TFieldValues>}
        label="Address 1"
        rules={{ required: 'Address 1 is required.' }}
        errors={errors}
        control={control}
      />
      <FormInput
        fieldName={'address2' as FieldPath<TFieldValues>}
        label="Address 2"
        errors={errors}
        control={control}
      />
      <FormInput
        fieldName={'city' as FieldPath<TFieldValues>}
        label="City"
        rules={{ required: 'City is required.' }}
        errors={errors}
        control={control}
      />
      <CountryAndStateField errors={errors} control={control} />
      <FormInput
        fieldName={'postalCode' as FieldPath<TFieldValues>}
        label="Zip/Postal Code"
        rules={{ required: 'Zip/Postal Code is required.' }}
        errors={errors}
        control={control}
      />
      {/* <FormInput
        fieldName={'mobile' as FieldPath<TFieldValues>}
        label="Mobile*"
        rules={{ required: 'Mobile phone number is required.' }}
        errors={errors}
        control={control}
      /> */}
    </div>
  );
}
